import getUrl from './getUrl.js';

export default function userShop(identifier, isFetchByShopPageUrl = false) {
    if(isFetchByShopPageUrl === true) {
        return fetch(`${ getUrl() }/v2/shop/page/${ identifier }`, {
			method: 'GET',
			headers: {
			'Content-type':'application/json',
            'Authorization': 'salaTokken'
			},
			credentials: 'include',
			})
			.then((res) => res.json())
    } else {
        return fetch(`${getUrl()}/v2/shop/${identifier}`, {
            method: 'GET',
            headers: {
            'Content-type':'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
        })
        .then((res) => res.json())
    }

}